import { POPULATE_WIDGET_DATA } from 'redux-types/embed'

export default function embed (state = null, action) {
  switch (action.type) {
    case POPULATE_WIDGET_DATA:
      return {
        ...action.data
      }
    default:
      return state
  }
}
